import { pushWithRegion } from 'actions/NavigationActions'
import { fetchTourV2Offer } from 'actions/TourV2Actions'
import LayoutContainer from 'components/Common/LayoutContainer'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import Divider from 'components/Luxkit/Divider'
import TailorMadeTourRequestForm from 'components/Tours/TailorMadeTour/TailorMadeTourRequestForm'
import TailorMadeTourTextualBlock from 'components/Tours/TailorMadeTour/TailorMadeTourTextualBlock'
import Group from 'components/utils/Group'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useQsQueryParams } from 'hooks/useQueryParams'
import { getTailorMadeTourRequestUrl } from 'lib/tours/tailorMadeTourUtils'
import { rem } from 'polished'
import React, { ComponentProps, useCallback, useEffect } from 'react'
import styled from 'styled-components'

const Container = styled(LayoutContainer)`
  padding-block: ${rem(40)};
  position: relative; /* so that the loading indicator overlay can stick to the right place */
`

function TailorMadeTourRequestPage() {
  const dispatch = useAppDispatch()
  const { tourOfferId, tourOfferVariationId } = useQsQueryParams<{ tourOfferId: string; tourOfferVariationId: string }>()

  const handleSubmission = useCallback<ComponentProps<typeof TailorMadeTourRequestForm>['onSubmit']>((requestId) => {
    dispatch(pushWithRegion(getTailorMadeTourRequestUrl(requestId)))
  }, [dispatch])

  useEffect(() => {
    dispatch(fetchTourV2Offer(tourOfferId))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tourOfferId])

  const isOfferLoading = useAppSelector<boolean | undefined>((state) => state.offer.offersLoading[tourOfferId])
  const offer = useAppSelector<App.Tours.TourV2Offer | undefined>((state) => state.offer.tourV2Offers[tourOfferId])
  const offerVariation: App.Tours.TourV2OfferVariation | undefined = offer?.variations[tourOfferVariationId]

  return <Container size="md">
    <LoadingIndicator visible={isOfferLoading === true} floating position="top" />
    <Group direction="vertical" gap={32} tabletGap={40}>
      <TailorMadeTourTextualBlock />
      <Divider kind="secondary" />
      <TailorMadeTourRequestForm
        tourOffer={offer}
        tourOfferVariation={offerVariation}
        onSubmit={handleSubmission}
      />
    </Group>
  </Container>
}

export default TailorMadeTourRequestPage
